import {
  List,
  ListItem,
  ListItemText,
  Checkbox,
  ListItemButton,
  ListItemIcon,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { GenCurrency } from '@pinnacleautomotive/clarity-components';

const StyledList = styled(List)(({ theme }) => ({
  display: 'block',
}));

const ListServices = ({ prices, selectedPrices, onSelectPrice }) => {
  return (
    <StyledList sx={{ columns: { xs: 1, md: 2 } }}>
      {prices?.map(price => {
        const labelId = `checkbox-list-secondary-label-${price.servicePriceId}`;
        const checked = selectedPrices.includes(price.servicePriceId);
        return (
          <ListItem key={price.servicePriceId} disablePadding>
            <ListItemButton
              onClick={() => onSelectPrice(price, !checked)}
              sx={{ pl: 0 }}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked}
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={
                  <>
                    {price.service.name} (
                    <GenCurrency value={price.price} />)
                  </>
                }
                primaryTypographyProps={{ variant: 'body1' }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </StyledList>
  );
};

export default ListServices;
